module.exports = __webpack_public_path__ + "img/service_wechat_5.dd97d616.png";